import { programmes } from "../Tuition Fees/programmes";
import { faqData } from "../FAQS/faqData";
import { scoreMatch, tokenize } from "../lib/fuzzySearch";

/**
 * Static pages that should be findable from the header search.
 * Keep in sync with the route table in src/App.js.
 */
export const STATIC_PAGES = [
  { title: "Home", path: "/", keywords: "zetech university homepage" },
  { title: "Programmes", path: "/programmes", keywords: "courses study degree diploma certificate" },
  { title: "Tuition Fees", path: "/tuition-fees", keywords: "fee structure cost payment tuition" },
  { title: "Fee Payments", path: "/fee-payments", keywords: "bank account paybill mpesa fees payment" },
  { title: "Application Process", path: "/application-process", keywords: "apply admission requirements intake" },
  { title: "Admissions: How to Apply, Documents & Intakes", path: "/admissions", keywords: "admissions apply application documents required intake dates campus life requirements kuccps how to apply" },
  { title: "Intakes (January, May & September)", path: "/intakes", keywords: "intake january may september admission dates apply deadline" },
  { title: "KUCCPS Placement", path: "/kuccps", keywords: "kuccps placement kcse grade cluster revision of choices self sponsored" },
  { title: "Student Portal & Online Services", path: "/student-portal", keywords: "portal login elearning library results fee statement sajili shahada almanac careers alumni" },

  { title: "International Students", path: "/international-students", keywords: "visa immigration foreign students" },
  { title: "Student Accommodation", path: "/student-accommodation", keywords: "hostel housing rooms accommodation" },
  { title: "FAQs", path: "/faqs", keywords: "questions answers help support" },
  { title: "Whistle Blowing", path: "/whistle-blowing", keywords: "whistle blowing see something say something report fraud corruption harassment misconduct safety anonymous ethics integrity confidential" },
  { title: "Exam Memos", path: "/exam-memos", keywords: "examinations timetable memo results" },
  { title: "Student Life", path: "/students-life", keywords: "clubs sports societies campus life" },
  { title: "Research", path: "/research", keywords: "research publications journals" },
  { title: "Our Institutes", path: "/institutes", keywords: "institutes centers" },
  { title: "AgriTech and Innovation Hub", path: "/agritech-innovation-hub", keywords: "agritech agriculture farming agribusiness short courses poultry dairy pig rabbit avocado drone hub" },
  { title: "Institute of Ageing Studies (IAS)", path: "/institutes/ias", keywords: "ageing aging gerontology geriatrics older persons elderly kinuthia wa mwangi ias institute" },
  { title: "Center for Professional Certifications (CPC)", path: "/professional-certifications", keywords: "cpc professional certifications short courses icdl cisco huawei computer packages graphic design digital marketing programming accounting quickbooks sage spss autocad languages hospitality pearson vue" },
  { title: "Conferences", path: "/conferences", keywords: "conference call for papers" },
  { title: "Innovations", path: "/innovations", keywords: "izethub incubation startups innovation" },
  { title: "About Zetech University", path: "/about-zu", keywords: "history about us overview" },
  { title: "Mission, Vision, Philosophy & Core Values", path: "/mission-vision", keywords: "mission vision values philosophy" },
  { title: "Quality Policy", path: "/quality-policy", keywords: "iso quality policy standards" },
  { title: "Governance", path: "/governance", keywords: "council management leadership vice chancellor" },
  { title: "Our Campuses", path: "/our-campuses", keywords: "ruiru thika road cbd pipeline campus location" },
  { title: "Charter & Accreditation", path: "/charter", keywords: "charter accreditation cue" },
  { title: "Our Foundation", path: "/our-foundation", keywords: "foundation scholarship bursary" },
  { title: "Service Charter", path: "/service-charter", keywords: "service standards commitments" },
  { title: "Zetech Anthem", path: "/zetech-anthem", keywords: "anthem song" },
  { title: "Corporate Social Responsibility", path: "/corporate-social-responsibility", keywords: "csr community outreach" },
  { title: "Testimonials", path: "/testimonials", keywords: "student stories reviews testimonials" },
  { title: "Blog", path: "/blog", keywords: "news articles stories blog" },
  { title: "Events", path: "/events", keywords: "events graduation open day calendar" },
  { title: "Sitemap", path: "/sitemap", keywords: "sitemap all pages" },
  { title: "Privacy Policy", path: "/privacy-policy", keywords: "privacy data protection" },
];

/** Search local (instant, offline) content: pages + programmes. */
export function searchLocalContent(term, limit = 8) {
  const tokens = tokenize(term);
  if (!tokens.length) return { pages: [], programmes: [], faqs: [] };

  const pages = STATIC_PAGES.map((page) => ({
    ...page,
    score: scoreMatch(`${page.title} ${page.keywords}`, tokens) + scoreMatch(page.title, tokens) * 2,
  }))
    .filter((page) => page.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, limit);

  const programmeHits = programmes
    .map((programme) => {
      const haystack = [
        programme.title,
        programme.shortTitle,
        programme.code,
        programme.school,
        programme.qualification,
        programme.award,
        programme.level,
        programme.category,
      ]
        .filter(Boolean)
        .join(" ");
      return {
        id: programme.id,
        title: programme.title,
        slug: programme.slug,
        school: programme.school,
        qualification: programme.qualification,
        score: scoreMatch(haystack, tokens) + scoreMatch(programme.title, tokens) * 2,
      };
    })
    .filter((p) => p.score > 0 && p.slug)
    .sort((a, b) => b.score - a.score)
    .slice(0, limit);

  const faqs = faqData
    .flatMap((group) =>
      group.questions.map((faq) => ({
        ...faq,
        category: group.category,
        score:
          scoreMatch(`${faq.question} ${faq.answer} ${group.category}`, tokens) +
          scoreMatch(faq.question, tokens) * 2,
      }))
    )
    .filter((faq) => faq.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 4);

  return { pages, programmes: programmeHits, faqs };
}

export { tokenize };
